import * as React from 'react'
import { sizes } from './const'

export interface CalendarProps {
    className?: string
    size?: 'small' | 'medium' | 'large'
}

export const CalendarIcon = ({
    className = 'js_CalendarIcon',
    size = 'medium',
}: CalendarProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className={`${className} ${sizes[size]}`}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={1}
        >
            <path
                d="M3 5h18v16H3V5ZM21 9H3M7 5V3M17 5V3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17 15h-2v2h2v-2Z"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
